export const normalizePrepositionVSpacing = (str: string) => {
  return str?.replace(/(^|\s)в\s+(?=\S)/g, '$1в\u00A0');
};
